import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import moment from 'moment';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import get from 'lodash/get';

import { getLatestListings } from './utils';

import NewsImage from '../NewsImage/NewsImage';
import NewsLink from '../NewsLink/NewsLink';

import css from './LatestEventsSection.module.scss';

const YESTERDAY = Date.now()-86400000;

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

function LatestEventsSection(props) {
  const { searchedCategory } = props;

  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      require('swiper/css');
      require('swiper/css/bundle');
      require('swiper/css/navigation');
    }

    getLatestListings({
      pub_listingType: 'provider',
      pub_hasAnyNews: true,
    })
      .then(resp => {
        const container = [];
        resp.forEach(l => {

          const events = get(l, 'attributes.publicData.events', []);
          const listingId = get(l, 'id.uuid', null);
          const posts = [...events];

          const targetEvents =
            (Array.isArray(posts) ? posts : []).filter(
              n => n && n?.title && n?.id
            ) || [];
          targetEvents
            .forEach(e => {
              e.author = l.author;
              e.listingId = listingId;
              e.companyName = get(l, 'attributes.title', null);
              return container.push(e)
            });
        });

        const sortedContainer = container.sort((a, b) => new Date(a?.eventDate?.date).getTime() - new Date(b?.eventDate?.date).getTime());

        setEvents(sortedContainer);
      })
      .catch(e => console.log(e));
  }, [searchedCategory]);

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 1.3 : 3;


  const pastEvents = events.filter(e => new Date(e?.eventDate?.date).getTime() < YESTERDAY);
  const noActualEvents = pastEvents?.length === events?.length;

  return events && events.length > 0 && !noActualEvents ? (
    <div className={css.sectionContent}>
      <h2 className={css.sectionTitle}>Upcoming events</h2>

      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: '.custom_next',
          prevEl: '.custom_prev',
        }}
        spaceBetween={10}
        slidesPerView={slidesToShow}
        onSwiper={swiper => { }}
        onSlideChange={() => { }}
      >
        <div className="custom_next">
          {' '}
          {/* we need to add our own arrows, SwiperJs doesn't show default ones  */}
          <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
        </div>
        <div className="custom_prev">
          <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
        </div>
        {events.map((e, index) => {
          const link = get(e, 'link', null);
          const title = get(e, 'title', '');
          const discountCode = get(e, 'discountCode', '');
          const imgUrl = get(e, 'image.url', null);

          const isPastEvent = YESTERDAY > new Date(e?.eventDate?.date).getTime();

          if (isPastEvent) return null

          return (
            <SwiperSlide key={index.toString()}>
              <div className={css.newsItem}>
                <div>
                  <div className={css.titleWrapper}>
                    {link ? (
                      <NewsLink
                        className={css.title}
                        link={link}
                      >
                        {title}
                      </NewsLink>
                    ) : (
                      <span className={css.title}>
                        {title}
                      </span>
                    )}
                  </div>
                  <NewsImage
                    imgUrl={imgUrl}
                    link={link}
                    imageClassName={css.image}
                    iconClassName={css.newsIcon}
                  />
                </div>
                {e?.eventDate?.date && moment(e?.eventDate?.date).format('ddd, MMM D, YYYY')}
                {discountCode && <div className={css.discountCode}>Discount code: {discountCode}</div>}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

    </div>
  ) : null;
}

export default LatestEventsSection;
